import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './ChartPlaceholder.scss';


const propTypes = {
  isVisible: PropTypes.bool.isRequired,
};

const chartIcon = require('./assets/chart-icon.png');

const ChartPlaceholder = ({ isVisible }) => {
  const chartPlaceholderClassNames = classNames({
    'chart-placeholder-wrapper': true,
    'is-visible': isVisible,
  });
  return (
    <div className={chartPlaceholderClassNames}>
      <div className="chart-placeholder">
        <div className="img-wrapper">
          <img src={chartIcon} alt="chart" />
        </div>
        <div className="text-wrapper">
          <span>There are no data available for this period.</span>
        </div>
      </div>
    </div>
  );
};
ChartPlaceholder.propTypes = propTypes;


export default ChartPlaceholder;



// WEBPACK FOOTER //
// ./src/containers/MainPanel/components/ChartPart/components/ChartPlaceholder/ChartPlaceholder.js